<template>
  <div>
    <div class="d-flex gap-2 mb-2">
      <button
        type="button"
        :class="['btn btn-sm', activeTab === 'edit' ? 'btn-primary' : 'btn-outline-secondary']"
        :disabled="readonly"
        @click="activeTab = 'edit'"
      >Edit</button>
      <button
        type="button"
        :class="['btn btn-sm', activeTab === 'preview' ? 'btn-primary' : 'btn-outline-secondary']"
        @click="activeTab = 'preview'"
      >Preview</button>
    </div>
    <textarea
      v-if="activeTab === 'edit'"
      class="form-control font-monospace"
      :id="inputId || undefined"
      :rows="rows"
      :value="modelValue"
      :disabled="readonly"
      :required="required"
      @input="$emit('update:modelValue', $event.target.value)"
    ></textarea>
    <div
      v-else
      class="border rounded p-3"
      v-html="renderedHtml"
    ></div>
  </div>
</template>

<script>
import { renderMarkdown } from '@/utils/renderMarkdown'

export default {
  name: 'MarkdownEditor',
  props: {
    modelValue: { type: String, default: '' },
    rows: { type: Number, default: 8 },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    inputId: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  data() {
    return { activeTab: 'edit' }
  },
  computed: {
    renderedHtml() {
      return renderMarkdown(this.modelValue)
    },
  },
  watch: {
    readonly(newVal) {
      if (newVal) this.activeTab = 'preview'
    },
  },
}
</script>
